import { createFileRoute, stripSearchParams } from "@tanstack/react-router"
import { TradingPage, type TradingTab } from "@/components/pages/trading/page"
import {
	openPositionsOptions,
	pendingSummaryOptions,
	tradesTotalsOptions,
} from "@/hooks/queries/trading"
import { useTabNavigation } from "@/hooks/use-tab-navigation"
import { tradingSearchSchema } from "@/lib/schemas/trades"

export const Route = createFileRoute("/_authenticated/trading")({
	validateSearch: tradingSearchSchema,
	search: {
		middlewares: [stripSearchParams(tradingSearchSchema.parse({}))],
	},
	loader: ({ context }) => {
		context.queryClient.prefetchQuery(tradesTotalsOptions("ytd"))
		context.queryClient.prefetchQuery(pendingSummaryOptions())
		context.queryClient.prefetchQuery(openPositionsOptions())
	},
	component: TradingRoute,
})

function TradingRoute() {
	const { tab: tabSearch } = Route.useSearch()
	const navigate = Route.useNavigate()
	const { tab, onTabChange } = useTabNavigation<TradingTab>(
		navigate,
		"trades",
		tabSearch,
	)
	return <TradingPage tab={tab} onTabChange={onTabChange} />
}
